module.exports = __webpack_public_path__ + "img/gift-cover-medium.df7bbfc9.png";